import { Component, Input, OnInit } from '@angular/core';
import { AtualizacoesAuditService } from '../../services/atualizacao-audit.service';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';

@Component({
  selector: 'app-historico-atualizacoes-list',
  templateUrl: './historico-atualizacoes-list.component.html',
  styleUrls: ['./historico-atualizacoes-list.component.scss']
})
export class HistoricoAtualizacoesListComponent extends BaseListComponent<any> implements OnInit {

  @Input() audit: any;
  atualizacoes: any[] = [];
  visivel: boolean = false;
  show: boolean = false;

  constructor(
    private myService: AtualizacoesAuditService,
  ) {
    super();
  }

  ngOnInit() {
    this.initLoadDataTable();

    this.addSub(
      EventSharedService.get('auditRefresh').subscribe((res) => {
        this.loading();
        this.initLoadDataTable();
      })
    )
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.getAtualizacoes(this.audit).subscribe({
        next: (res) => {
          this.initList(res);
          this.loaded();
        },
        error: (error) => {
          this.loaded();
        },
      })
    );
  }

  initList(obj: any[]) {
    obj.forEach(audit => {
      audit.summary = '<li>' + audit.summary.replace(/[\r\n]+/g, "</li><li>") + '</li>';
      audit.summary = audit.summary.replace("\n", "</li><li>");
    });
    this.atualizacoes = obj;
  }
}
